module.exports = "/_next/static/images/d82cacec173e63ace6f7f9c4bab8741a-nu-card-lg@1x.jpg";